import type { FC } from 'react';
import { DEFAULT_CHART_COLOR } from '../Chart';
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

export type LineChartData = Partial<Record<string, unknown>> & {
    color?: string;
};
interface LineChartComponentProps {
    chartData?: LineChartData[];
    chartKeys: string[];
    showLegend?: boolean;
}


const LineChartComponent: FC<LineChartComponentProps> = props => {
    const {
        chartData,
        chartKeys,
        showLegend = true,
    } = props;

    if (!chartData) {
        return null;
    }

    return (
        <div className="line-chart-component">
            <ResponsiveContainer>
                <LineChart data={chartData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    {chartKeys.map((key, index) => {
                        const uniqueKey = `${key}-${index}`;
                        const defaultColor = chartData[0].color || DEFAULT_CHART_COLOR;
                        const barColor = (chartData[0][`${key}-color`] as string || defaultColor);
                        return (
                            <Line
                                key={uniqueKey}
                                type="monotone"
                                dataKey={key}
                                stroke={barColor}
                                activeDot={{ r: 8 }}
                            />
                        );
                    })}
                    {showLegend && (
                        <Legend
                            align="center"
                            verticalAlign="bottom"
                            wrapperStyle={{ paddingTop: '16px' }}
                        />
                    )}
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

export default LineChartComponent;
